import { Check, Info } from "@phosphor-icons/react";
import { fmtDate, money } from "@/lib/api";

export const INDICATOR_TEXT = "The Mission Control Indicator is NOT included in the lecture price. The indicator is available only to those who have attended the one-day lecture. Indicator pricing will be available on TradingView.com in the near future.";

export const IndicatorNotice = ({ testid = "indicator-notice", className = "" }) => (
  <div className={`flex items-start gap-2 rounded-md border-2 border-[#0B1B33] bg-[#FFF8E6] p-3 text-sm font-bold text-[#0B1B33] ${className}`} data-testid={testid}>
    <Info size={18} weight="fill" className="mt-0.5 shrink-0 text-[#C8382E]" />{INDICATOR_TEXT}
  </div>
);

export const earlyEnd = (t, tz) => (t?.ends_at ? `${fmtDate(new Date(Date.parse(t.ends_at) - 60000).toISOString(), tz)}, 11:59 p.m.` : "");

const STATUS = { not_started: "Starts after early-bird", ended: "Early-bird has ended", vip_benefits_missing: "Coming soon", sold_out: "Sold out", no_price: "Not on sale yet" };

const Card = ({ t, tz, sel, onSelect, left, benefits }) => {
  const off = !t.on_sale;
  return (
    <button type="button" disabled={!onSelect || off} onClick={() => onSelect?.(t.code)} data-testid={`price-card-${t.code}`}
      className={`flex h-full flex-col rounded-md border-2 p-5 text-left transition-colors ${sel ? "border-[#E0A21B] bg-[#E0A21B]/10" : "border-[#0B1B33]/10"} ${off ? "opacity-60" : onSelect ? "hover:border-[#0B1B33]/40" : ""}`}>
      <span className="flex items-center justify-between gap-2">
        <span className="font-display text-xl font-bold uppercase">{t.name}</span>
        {sel && <Check weight="bold" className="text-[#1E8E5A]" />}
      </span>
      <span className="mt-2 font-mono-num text-2xl font-bold" data-testid={`price-card-amount-${t.code}`}>{money(t.price_cents)}</span>
      <span className="text-xs font-semibold text-[#475569]">plus applicable taxes</span>
      <span className="mt-2 text-xs text-[#475569]">Lunch and coffee breaks included</span>
      {t.code === "early" && t.ends_at && <span className="mt-1 text-xs font-semibold text-[#1E8E5A]" data-testid="price-card-early-end">Until {earlyEnd(t, tz)} local time</span>}
      {t.code === "vip" && benefits && <span className="mt-2 whitespace-pre-line text-xs text-[#334155]" data-testid="vip-benefits">{benefits}</span>}
      {t.code === "vip" && left !== undefined && t.on_sale && <span className="mt-1 text-xs font-bold text-[#C8382E]" data-testid="tier-left-vip">{left} of {t.capacity} VIP seats left</span>}
      {off && t.reason && <span className="mt-2 text-xs font-bold uppercase text-[#C8382E]" data-testid={`price-card-status-${t.code}`}>{STATUS[t.reason] || "Not on sale"}</span>}
    </button>
  );
};

export const PriceCards = ({ tiers = [], tz, selected, onSelect, tierLeft = {}, vipBenefits = "", compact = false }) => {
  const show = ["early", "regular", "vip"].map((c) => tiers.find((t) => t.code === c)).filter(Boolean);
  if (!show.length) return <p className="text-sm text-[#475569]" data-testid="prices-not-set">Prices will be announced when registration opens.</p>;
  const early = show.find((t) => t.code === "early");
  const reg = show.find((t) => t.code === "regular");
  return (
    <div className="space-y-3" data-testid="price-cards">
      <div className={`grid gap-3 ${compact ? "grid-cols-1" : "md:grid-cols-3"}`}>
        {show.map((t) => <Card key={t.code} t={t} tz={tz} sel={selected === t.code} onSelect={onSelect} left={tierLeft[t.code]} benefits={t.code === "vip" ? vipBenefits : ""} />)}
      </div>
      {early && reg && <p className="text-sm font-semibold" data-testid="price-schedule">Early-bird {money(early.price_cents)} until {early.ends_at ? earlyEnd(early, tz) : "11:59 p.m. local time before your class"}, then {money(reg.price_cents)}.</p>}
      <IndicatorNotice testid="indicator-notice-pricing" />
    </div>
  );
};
